import { c as _c } from "react/compiler-runtime";
import { FormInput, Modal, Popover, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { InternalError } from '@systemeio/util';
import { createDomain } from 'modules/profile/mailing-settings/api/mailing-settings-domain-api';
import DnsSettingsModal from 'modules/profile/mailing-settings/components/dns-settings-modal';
import { MailingSettingsDomainDnsSettingsInterface, MailingSettingsDomainErrorResponseContentInterface, MailingSettingsDomainErrorsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
const defaultErrors: MailingSettingsDomainErrorsInterface = {
  domainName: '',
  common: []
};
function SetupDomainAuthentication(t0) {
  const $ = _c(58);
  const {
    updateDomainTable
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [tempState, setTempState] = useState("");
  const [errors, setErrors] = useState(defaultErrors);
  const [isFetching, setIsFetching] = useState(false);
  const [dnsSettingsToSetup, setDnsSettingsToSetup] = useState(null);
  const [domainId, setDomainId] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpened(false);
      setTempState("");
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeSetupDomainModal = t1;
  let t2;
  if ($[1] !== t || $[2] !== tempState || $[3] !== updateDomainTable) {
    t2 = async () => {
      ;
      try {
        setIsFetching(true);
        setErrors(defaultErrors);
        const {
          data
        } = await createDomain({
          domainName: tempState
        });
        await updateDomainTable();
        setIsFetching(false);
        toast.success(t("dashboard.settings.mailing.dns_settings_domain_authentication_added_title"));
        setDnsSettingsToSetup(data.dnsSettings);
        setDomainId(data.id);
        closeSetupDomainModal();
      } catch (t3) {
        const e = t3;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          const mailingSettingsDomainErrors = e.errors as unknown as MailingSettingsDomainErrorResponseContentInterface;
          setErrors(prev => ({
            ...prev,
            domainName: mailingSettingsDomainErrors.fields.domainName?.join("")
          }));
          if (e.errors.common) {
            const commonErrors = e.errors.common;
            setErrors(prev_0 => ({
              ...prev_0,
              common: commonErrors
            }));
          }
        } else {
          if (e instanceof InternalError) {
            setErrors(t("core.error.internal_error_message"));
          }
        }
        toast.error(t("global.error"));
      }
    };
    $[1] = t;
    $[2] = tempState;
    $[3] = updateDomainTable;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleConfirm = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpened(true);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.settings.mailing.dns_settings_setup_title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className="text-brand-primary cursor-pointer" onClick={t3}>{t4}</div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("dashboard.settings.mailing.dns_settings_setup_popover_title");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Popover label={<div className="[&>a]:text-brand-primary" dangerouslySetInnerHTML={{
      __html: t6
    }} />}>{_temp}</Popover>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors flex items-center gap-3 px-6 pb-2 pt-6">{t5}{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("dashboard.settings.mailing.setup_domain_modal_title");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("dashboard.settings.mailing.setup_domain_modal_domain_name_title");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("dashboard.settings.mailing.setup_domain_modal_domain_name_popover_title");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <Popover label={t11} popoverClassName="w-[300px] sm:w-[350px]">{_temp2}</Popover>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <div className="flex items-center gap-1.5">{t10}{t12}</div>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = e_0 => setTempState(e_0.target.value);
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== errors.domainName || $[30] !== t13 || $[31] !== tempState) {
    t15 = <FormInput label={t13} required={true} value={tempState} onChange={t14} error={errors.domainName} />;
    $[29] = errors.domainName;
    $[30] = t13;
    $[31] = tempState;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== handleConfirm) {
    t16 = async e_1 => {
      e_1.preventDefault();
      await handleConfirm();
    };
    $[33] = handleConfirm;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t) {
    t17 = t("global.save");
    $[35] = t;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== isFetching || $[38] !== t16 || $[39] !== t17) {
    t18 = <div className="flex justify-center gap-4"><PrimaryButton isFetching={isFetching} width="large" onClick={t16} type="submit">{t17}</PrimaryButton></div>;
    $[37] = isFetching;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== errors.common) {
    t19 = errors.common && <>{errors.common.map(_temp3)}</>;
    $[41] = errors.common;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t15 || $[44] !== t18 || $[45] !== t19) {
    t20 = <form className="flex flex-col gap-6 lg:gap-7">{t15}{t18}{t19}</form>;
    $[43] = t15;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== opened || $[48] !== t20 || $[49] !== t9) {
    t21 = <Modal opened={opened} onClose={closeSetupDomainModal} title={t9} className="max-w-2xl">{t20}</Modal>;
    $[47] = opened;
    $[48] = t20;
    $[49] = t9;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== dnsSettingsToSetup || $[52] !== domainId) {
    t22 = dnsSettingsToSetup && domainId && <DnsSettingsModal domainId={domainId} dnsSettings={dnsSettingsToSetup} opened={true} onClose={() => {
      setDnsSettingsToSetup(null);
      setOpened(false);
    }} />;
    $[51] = dnsSettingsToSetup;
    $[52] = domainId;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t21 || $[55] !== t22 || $[56] !== t8) {
    t23 = <>{t8}{t21}{t22}</>;
    $[54] = t21;
    $[55] = t22;
    $[56] = t8;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
}
function _temp3(error, index) {
  return <p className="text-red px-6 text-sm" key={index}>{error}</p>;
}
function _temp2(show_0) {
  return <QuestionMarkIcon className={`${show_0 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
export default SetupDomainAuthentication;